import UsdtABI from "../utils/UsdtABI.json";
import LuckifyABI from "../utils/LuckifyABI.json";
import ClaimABI from "../utils/ClaimABI.json";
import web3NoAccount from "./web3";
import PoolAbi from "./poolAbi.json";
import PoolAbiV3 from "./uniswapeV4.json";
import CrashGame from "./CrashGameAbi.json";
import LuckToken from "./luckAbi.json";
const getContract = (abi, address, web3) => {
  const _web3 = web3 ?? web3NoAccount;
  return new _web3.eth.Contract(abi, address);
};

export const getBalance = (address, web3) => {
  return getContract(UsdtABI, address, web3);
};

export const getLiquidityPool = (address, web3) => {
  return getContract(LuckifyABI, address, web3);
};

export const getClaimContract = (address, web3) => {
  return getContract(ClaimABI, address, web3);
};

export const getPoolContract = (address, web3) => {
  return getContract(PoolAbi, address, web3);
};

export const getPoolV4Contract = (address, web3) => {
  return getContract(PoolAbiV3, address, web3);
};

export const CrashGameContract = (address, web3) => {
  return getContract(CrashGame, address, web3);
};

export const LuckTokenConTract = (address, web3) => {
  return getContract(LuckToken, address, web3);
};
